'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _lodash = require('lodash.merge');

var _lodash2 = _interopRequireDefault(_lodash);

var _createBroadcast = require('../utils/create-broadcast');

var _misc = require('../utils/misc');

var _theme = require('../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var THEME_MIXIN_CHANNEL = '__reactackle_theme_mixin__';

var propTypes = {
  mixin: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};

var defaultProps = {
  mixin: {}
};

var contextTypes = _defineProperty({}, THEME_MIXIN_CHANNEL, _propTypes2.default.func);

var childContextTypes = _defineProperty({}, THEME_MIXIN_CHANNEL, _propTypes2.default.func.isRequired);

var Theme = exports.Theme = function (_Component) {
  _inherits(Theme, _Component);

  function Theme(props, context) {
    _classCallCheck(this, Theme);

    var _this = _possibleConstructorReturn(this, (Theme.__proto__ || Object.getPrototypeOf(Theme)).call(this, props, context));

    _this._unsubscribeToOuter = null;
    _this._unsubscribeDefaultTheme = null;
    _this._broadcast = null;
    _this._outerMixin = {};
    _this._currentMixin = {};

    _this.state = {
      theme: {}
    };

    _this._updateTheme = _this._updateTheme.bind(_this);
    return _this;
  }

  _createClass(Theme, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _extends({}, this.context, _defineProperty({}, THEME_MIXIN_CHANNEL, this._broadcast.subscribe));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (this.context[THEME_MIXIN_CHANNEL]) {
        var subscribe = this.context[THEME_MIXIN_CHANNEL];
        this._unsubscribeToOuter = subscribe(function (mixin) {
          _this2._outerMixin = mixin;
        });
      }

      this._currentMixin = this._getMixin(this.props.mixin);
      this._broadcast = (0, _createBroadcast.createBroadcast)(this._currentMixin);
      this._unsubscribeDefaultTheme = _theme.defaultThemeBlueprintBroadcast.subscribe(this._updateTheme);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.mixin !== nextProps.mixin) {
        this._currentMixin = this._getMixin(nextProps.mixin);

        this._broadcast.publish(this._currentMixin);
        this._updateTheme();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribeDefaultTheme();
      if (this.context[THEME_MIXIN_CHANNEL]) this._unsubscribeToOuter();
    }
  }, {
    key: '_updateTheme',
    value: function _updateTheme() {
      this.setState({ theme: (0, _theme.composeReactackleTheme)(this._currentMixin) });
    }
  }, {
    key: '_getMixin',
    value: function _getMixin(mixin) {
      if ((0, _misc.isFunction)(mixin)) return mixin(this._outerMixin);

      if (this.context[THEME_MIXIN_CHANNEL]) return (0, _lodash2.default)({}, this._outerMixin, mixin);

      return this.props.mixin;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _styledComponents.ThemeProvider,
        { theme: this.state.theme },
        this.props.children
      );
    }
  }]);

  return Theme;
}(_react.Component);

Theme.childContextTypes = childContextTypes;
Theme.contextTypes = contextTypes;
Theme.propTypes = propTypes;
Theme.defaultProps = defaultProps;
Theme.displayName = 'Theme';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/Theme/Theme.js
// module id = 622
// module chunks = 0